module.exports = __webpack_public_path__ + "img/avatar1.1d145bff.png";